import { ActionTree } from 'vuex'
import { BatteryRechargingCapacityState } from './types';
import { RootState } from '@/store/types';

export const actions: ActionTree<BatteryRechargingCapacityState, RootState> = {
}
